import { callForVersion, getReserveChatUrl, injectScript, roundToNearest5 } from './helpers';
import { SUPPORT_CHAT_MODULE } from './constants';
import { IChatInitOptions, IChatUpdateOptions, IUserProps } from './types';
const getChatModule = () => global[SUPPORT_CHAT_MODULE];

export const initChat = async ({ url, ...options }: IChatInitOptions): Promise<void> => {
  let urlToChat = '';
  if (!getChatModule()) {
    try {
      const data = await callForVersion(url);

      urlToChat = data.url || getReserveChatUrl(url);
    } catch (e) {
      const reserveUrl = getReserveChatUrl(url);
      urlToChat = reserveUrl;
    }
    const timestamp = roundToNearest5();
    await injectScript(`${urlToChat}?i=${timestamp}`);
  }

  getChatModule()?.initChat(options);
};

export const updateChat = (options: IChatUpdateOptions) => {
  const chatModule = getChatModule();

  if (!chatModule) {
    console.error('Chat was not initiated');
    return;
  }

  if (!chatModule.updateChat) {
    console.error('Chat module does not have updateChat method');
    return;
  }

  chatModule.updateChat(options);
};

export const updateUserData = (options: IUserProps) => {
  const chatModule = getChatModule();

  if (!chatModule) {
    console.error('Chat was not initiated');
    return;
  }

  if (!chatModule.updateUserData) {
    console.error('Chat module does not have updateUserData method');
    return;
  }

  chatModule.updateUserData(options);
};

export const isChatActive = () => {
  const chatModule = getChatModule();

  if (!chatModule) {
    console.error('Chat was not initiated');
    return;
  }

  if (!chatModule.isChatActive) {
    console.error('Chat module does not have isChatActive method');
    return;
  }

  return chatModule.isChatActive();
};

export const showChat = () => {
  const chatModule = getChatModule();

  if (!chatModule) {
    console.error('Chat was not initiated');
    return;
  }

  if (!chatModule.showChat) {
    console.error('Chat module does not have showChat method');
    return;
  }

  chatModule.showChat();
};

export const hideChat = () => {
  const chatModule = getChatModule();

  if (!chatModule) {
    console.error('Chat was not initiated');
    return;
  }

  if (!chatModule.hideChat) {
    console.error('Chat module does not have hideChat method');
    return;
  }

  chatModule.hideChat();
};

export const unmountChat = () => {
  const chatModule = getChatModule();

  if (!chatModule) {
    console.error('Chat was not initiated');
    return;
  }

  if (!chatModule.unmountChat) {
    console.error('Chat module does not have unmountChat method');
    return;
  }

  chatModule.unmountChat();
};

export default { initChat, updateChat, updateUserData, isChatActive, showChat, hideChat, unmountChat };
